<div class="detail-container">

	<custom-alert class="alert-container-in-modal"></custom-alert>

	<!--	header section	-->
	<div class="container-header">
		<mat-panel-title *ngIf="'titlePage'!=null"
						 class="title">
			{{ 'DETAIL_PAGE' | translate }}
		</mat-panel-title>
		<span (click)="toggleFullscreen()">
			<mat-icon>{{ isFullscreen ? 'fullscreen_exit' : 'fullscreen' }}</mat-icon>
		</span>
	</div>


	<!--	while loading	-->
	<ng-container *ngIf="isLoading; else loadComplete">
		<div
			class="loading-panel">
			{{ 'LABEL_LOADING' | translate }}
		</div>
	</ng-container>

	<!--	after loading	-->

	<ng-template #loadComplete>

		<!--	in case of error	-->
		<ng-container *ngIf="errorOccurred; else noError">
			<detail-error></detail-error>
		</ng-container>

		<!--	if everything is ok	-->
		<ng-template #noError>
			<div *ngFor=" let section of sections"
				 style="width: 100%">
				<div class="container-section">
					<div *ngIf="section.layoutSectionId == 'LYO_DETAIL_SECTABLE'">
						<detail-data-table
							[apiParent]="apiParent"
							[apiUrl]="section.apiUrl"
							[titlePage]="section.pageDescr"
							[pageId]="section.pageId"
							[id]="id"
							tableContainerClass="overflow-auto"
						></detail-data-table>
					</div>
					<div *ngIf="section.layoutSectionId == 'LYO_DETAIL_SECFORM'">
						<form-page
							[apiParent]="apiParent"
							[apiUrl]="section.apiUrl"
							[id]="id"
							[datasetData]="convertsDatasetData(section.dataset.lData)"
							[actionSet]="actionSet"
						></form-page>
					</div>
				</div>
			</div>
		</ng-template>

		<custom-btn color="primary"
					(click)="closeDialog()">
			{{ 'LABEL_CLOSE' | translate }}
		</custom-btn>

	</ng-template>

</div>